// // Input If Filled
// const formInputs = document.querySelectorAll("input");
// formInputs.forEach((e) => {
//     e.addEventListener('input', () => {
//         e.value !== "" ? e.classList.add('filled') : e.classList.remove('filled')
//     });
// });

// // Textarea If Filled
// const formTextarea = document.querySelectorAll("textarea");
// formTextarea.forEach((e) => {
//     e.addEventListener('input', () => {
//         e.value !== "" ? e.classList.add('filled') : e.classList.remove('filled')
//     });
// });

// // Slect Plain
// const formSelecterPlain = document.querySelectorAll(".form-select-plain");

// formSelecterPlain.forEach(formSelecterPlainItem => {
//     const formSelectPlain = formSelecterPlainItem.querySelector("select");

//     // Select if filled
//     formSelectPlain.addEventListener('change', (e) => {
//         e.target.selectedIndex >= 1 ? e.target.classList.add('filled') : e.target.classList.remove('filled')
//     })
// });


// // Select
// // Look for any elements with the class "custom-select":
// const formSelecter = document.querySelectorAll(".form-select-custom");

// formSelecter.forEach(formSelecterItem => {
//     const formSelect = formSelecterItem.querySelector("select");

//     // Select if filled
//     formSelect.addEventListener('change', (e) => {
//         e.target.selectedIndex >= 1 ? e.target.classList.add('filled') : e.target.classList.remove('filled')
//     })

//     // For each element, create a new DIV that will act as the selected item:
//     const selectedItem = document.createElement("DIV");
//     selectedItem.setAttribute("class", "select-selected");
//     selectedItem.innerHTML = formSelect.options[formSelect.selectedIndex].innerHTML;
//     formSelecterItem.appendChild(selectedItem);

//     // For each element, create a new DIV that will contain the option list:
//     const optionList = document.createElement("DIV");
//     optionList.setAttribute("class", "select-items select-hide");

//     // For each option in the original select element, create a new DIV that will act as an option item:
//     formSelect.querySelectorAll('option').forEach(option => {
//         const newOption = document.createElement("DIV");
//         newOption.innerHTML = option.innerHTML;
//         newOption.dataset.value = option.value;
                
//         newOption.addEventListener("click", function () {
//             // When an item is clicked, update the original select box and the selected item:
//             const currentOptionList = this.parentNode;
//             const currentFilterSelect = currentOptionList.parentNode;
//             this.setAttribute("class", "selected");

//             const selectedOptions = currentOptionList.querySelectorAll(".selected");
//             selectedOptions.forEach(selectedOption => {
//                 selectedOption.removeAttribute("class");
//             });

//             const selectSelected = currentFilterSelect.querySelector(".select-selected");
//             selectSelected.innerHTML = this.innerHTML;
//             selectSelected.click();

//             const originSelect = currentFilterSelect.querySelector("select");
//             originSelect.value = this.dataset.value;
//             originSelect.dispatchEvent(new Event('change'));
//         });

//         optionList.appendChild(newOption);
//     });

//     formSelecterItem.appendChild(optionList);

//     selectedItem.addEventListener("click", function (event) {
//         // When the select box is clicked, close any other select boxes, and open/close the current select box:
//         if (!this.classList.contains("select-arrow-active")) {
//             event.stopPropagation();
//             closeAllOptionLists(this);
//             this.nextSibling.classList.toggle("select-hide");
//             this.classList.add("select-arrow-active");
//         }
//     });
// });

// function closeAllOptionLists(element) {
//     // A function that will close all select boxes in the document, except the current select box:
//     const listsToHide = [];
//     const optionLists = document.querySelectorAll(".select-items");
//     const selectedOptions = document.querySelectorAll(".select-selected");

//     for (let i = 0; i < selectedOptions.length; i++) {
//         if (element == selectedOptions[i]) {
//             listsToHide.push(i)
//         }
//         else {
//             selectedOptions[i].classList.remove("select-arrow-active");
//         }
//     }

//     optionLists.forEach(optionList => {
//         if (listsToHide.indexOf(optionList)) {
//             optionList.classList.add("select-hide");
//         }
//     });
// }

// // If the user clicks anywhere outside the select box, then close all select boxes:
// document.addEventListener("click", closeAllOptionLists);

// // Character Counter
// const textareasWithMaxLength = document.querySelectorAll('textarea[maxlength], input[maxlength]');

// textareasWithMaxLength.forEach(charCounting => {
//     const formCount = charCounting.parentElement.querySelector('.form-count');
//     const maxLength = parseInt(charCounting.maxLength);

//     if(formCount && maxLength > 0) {
//         formCount.innerHTML = `0/${maxLength} Zeichen`;

//         charCounting.addEventListener('input', function (event) {
//             const charCurrentLength = event.target.value.length;

//             formCount.innerHTML = `${charCurrentLength}/${maxLength} Zeichen`;
//         });
//     }
// });

// const bewerbenSubmit = document.getElementById('zukunftsgestalter_submit');

// // disable button on submit
// if(bewerbenSubmit) {
//     bewerbenSubmit.addEventListener('click', function() {
//         setTimeout(function () {
//             bewerbenSubmit.disabled = true;
//             bewerbenSubmit.classList.add('is-loading');
//             const label = bewerbenSubmit.querySelector('.btn-label');
//             if(label) label.textContent = 'Bitte warten...';
//         }, 0); 
//     });
// }

// const conditionalFormFields = document.querySelectorAll('[data-show-if]');
// const toggleHidden = function(isMultiple, showIf, conditionalFormField) {
//     const addition = isMultiple ? '[]' : '';
//     const checkedInput = document.querySelector('input[name="' + showIf[0] + addition + '"][value="' + showIf[1] + '"]:checked');

//     if(checkedInput) {
//         conditionalFormField.classList.remove('form-field--hidden');
//     }
//     else {
//         conditionalFormField.classList.add('form-field--hidden');
//     }
// }

// conditionalFormFields.forEach(conditionalFormField => {
//     const showIf = conditionalFormField.dataset.showIf.split('=');
//     let inputs = document.querySelectorAll('input[name="' + showIf[0] + '"]');
//     let isMultiple = false;

//     if(!inputs.length) {
//         inputs = document.querySelectorAll('input[name="' + showIf[0] + '[]"]');
//         isMultiple = true;
//     }

//     if(inputs.length) {
//         inputs.forEach(input => {
//             toggleHidden(isMultiple, showIf, conditionalFormField);

//             input.addEventListener('input', function() {
//                 toggleHidden(isMultiple, showIf, conditionalFormField);
//             })
//         })
//     }
// });

// const errorField = document.querySelector('.form-field.error');

// if(errorField && window.location.hash.length == 0) {
//     window.scrollTo(0, errorField.getBoundingClientRect().y - 100);
// }

// const errorFields = document.querySelectorAll('.form-field.error');

// errorFields.forEach(field => {
//     const inputs = field.querySelectorAll('input, select, textarea');

//     inputs.forEach(input => {
//         const eventType = input.tagName === 'SELECT' ? 'change' : 'input';

//         input.addEventListener(eventType, () => {
//             console.log(field);

//             field.classList.remove('error');
//             const errorInfo = field.querySelector('span.error-info');

//             if(errorInfo) {
//                 errorInfo.remove();
//             }
//         });
//     });
// });

// const submitButtons = document.querySelectorAll('button[type="submit"][value="Submit"]');

// // disable button on submit
// submitButtons.forEach(submitButton => {
//     submitButton.addEventListener('click', function() {
//         setTimeout(function () {
//             let index = 0;
//             submitButtons.forEach(btn => {
//                 btn.disabled = true;
//                 btn.classList.add('is-loading');
//                 const label = btn.querySelector('.btn-label');
//                 if(label) label.textContent = 'Bitte warten...';

//                 if(index > 0) {
//                     btn.remove();
//                 }

//                 index++;
//             }); 
//         }, 0);
//     });
// });


// // number input disallow point
// const numberInputs = document.querySelectorAll('#bewerbung-form input[type="number"]');

// numberInputs.forEach(numberInput => {
//     numberInput.addEventListener('input', function(event) {
//         const value = numberInput.value;
//         const regex = /\./;
//         const hasPoint = regex.test(value);

//         if(hasPoint) {
//             numberInput.value = numberInput.value.replace(/\D+/g, '');
//             // numberInput.value = value.replace('.', '');
//         }
//     });

//     numberInput.addEventListener('keydown', function(event) {
//         // Allow: Backspace, Delete, Tab, Escape, Enter, and Arrow keys
//         if (
//             event.key === 'Backspace' || 
//             event.key === 'Delete' || 
//             event.key === 'Tab' || 
//             event.key === 'Escape' || 
//             event.key === 'Enter' || 
//             (event.key === 'ArrowLeft' || event.key === 'ArrowRight')
//         ) {
//             return; // Allow these keys
//         }

//         // Allow digits (0-9)
//         if (event.key >= '0' && event.key <= '9') {
//             return; // Allow number keys
//         }

//         // If the key is not allowed, prevent the default action
//         event.preventDefault();
//     });
// });

// Frontend file size and type check
document.querySelectorAll('input[type="file"]').forEach(fileInput => {
    const showError = function(formField, message) {
        formField.classList.add('error');

        let errorInfo = formField.querySelector('.error-info');
        if(!errorInfo) {
            errorInfo = document.createElement('span');
            errorInfo.classList.add('error-info');
            errorInfo.setAttribute('role', 'alert');
            formField.querySelector('.form-file').appendChild(errorInfo);
        }
        errorInfo.textContent = message;
    };

    const clearError = function(formField) {
        formField.classList.remove('error');
        const errorInfo = formField.querySelector('.error-info');
        if(errorInfo) errorInfo.remove();
    };

    fileInput.addEventListener('change', function() {
        const container = fileInput.closest('.form-file-container');
        const maxSizeInput = container ? container.querySelector('input[name="MAX_FILE_SIZE"]') : null;
        const maxSize = maxSizeInput ? parseInt(maxSizeInput.value, 10) : 0;
        const formField = fileInput.closest('.form-field');

        if(!formField) return;

        if(!fileInput.files.length) {
            clearError(formField);
            return;
        }

        const file = fileInput.files[0];
        const allowedExtensions = fileInput.accept
            ? fileInput.accept.split(',').map(ext => ext.trim().toLowerCase().replace(/^\./, '')).filter(Boolean)
            : [];

        if(allowedExtensions.length && !allowedExtensions.includes(file.name.split('.').pop().toLowerCase())) {
            fileInput.value = '';
            showError(formField, `Die Datei "${file.name}" hat ein nicht erlaubtes Format. Erlaubt sind: ${fileInput.accept}`);
            return;
        }

        if(maxSize && file.size > maxSize) {
            fileInput.value = '';
            showError(formField, `Die Datei "${file.name}" ist zu groß. Die maximale Dateigröße beträgt ${(maxSize / (1024 * 1024)).toFixed(1)} MB.`);
            return;
        }

        clearError(formField);
    });
});

// Deletion buttons for file uploads
document.querySelectorAll('.btn-reset-file').forEach(button => {
    button.addEventListener('click', function() {
        const fileInputId = this.dataset.fileInputId;
        const fileInput = document.getElementById(fileInputId);
        if (fileInput) {
            fileInput.value = ''; // Clear the selected file
        }
    });
});
